import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing, zIndex }: Theme) =>
  createStyles({
    root: {},
    label: {
      marginBottom: spacing(0.5),
    },
    option: {
      fontWeight: 500,
    },
    spaceSelected: {
      backgroundColor: colors.white.lightest,
      border: `1px solid #d2d2dd`,
      borderRadius: 6,
      boxShadow: 'none',
      height: 36,
      padding: spacing(1.5, 3),
      width: '100%',
    },
    spaceSelectedName: {
      color: colors.kato.grey[900],
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      userSelect: 'none',
      whiteSpace: 'nowrap',
    },
    clearIcon: {
      cursor: 'pointer',
      color: '#7E8899', //TODO replace after creating new palette
      zIndex: zIndex.drawer + 1,
      marginLeft: spacing(0.5),
      fontSize: 20,
      padding: 2,

      '&:hover': {
        color: colors.red.main,
      },
    },
  });
